export interface MetricData {
  operation: string;
  duration: number;
  success: boolean;
  error?: string;
  metadata?: Record<string, unknown>;
  timestamp?: number;
}

export class MetricsService {
  private metrics: MetricData[] = [];

  recordMetric(data: MetricData): void {
    this.metrics.push({
      ...data,
      timestamp: Date.now(),
    });

    // Отправляем метрики в аналитику (если настроена)
    this.sendToAnalytics(data);
  }

  getMetrics(operation?: string): MetricData[] {
    return operation
      ? this.metrics.filter((m) => m.operation === operation)
      : this.metrics;
  }

  clearMetrics(): void {
    this.metrics = [];
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private sendToAnalytics(_data: MetricData): void {
    // Интеграция с системой аналитики
    // Metric logging disabled
  }
}
